import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-exit",
  "use": "icon-exit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-exit\">\n<style type=\"text/css\">\n\t#icon-exit .st0{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<path class=\"st0\" d=\"M12,3H3v18h9\" />\n<path class=\"st0\" d=\"M16.5,16.5L21,12l-4.5-4.5\" />\n<path class=\"st0\" d=\"M8,12h13\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol